exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{@page{margin-top:35mm}.visualizado[data-v-88b84d2e]{display:block;margin-bottom:30px}}@media screen{.visualizado[data-v-88b84d2e]{display:none}.marca[data-v-88b84d2e]:after{content:url(/img/newlogo.png);font-size:15em;opacity:.1;z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:fixed;top:120px;right:0;bottom:0;left:0;-webkit-pointer-events:none;-moz-pointer-events:none;-ms-pointer-events:none;-o-pointer-events:none;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-88b84d2e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/factura/FacturaPagoCuentaCobrar.vue
// module id = 629
// module chunks = 0